import { defineComponent as _defineComponent } from 'vue'
import CcCard from '@/views/Automation/CampaignCreatorV2/components/CcCard/CcCard.ts.vue';
import CcCardItem from '@/views/Automation/CampaignCreatorV2/components/CcCard/CcCardItem.ts.vue';
import CcError from '@/views/Automation/CampaignCreatorV2/components/CcError/CcError.ts.vue';
import CcVariableTags from '@/views/Automation/CampaignCreatorV2/components/CcVariableTags/CcVariableTags.ts.vue';
import TreeselectProfileOption from '@/views/Automation/CampaignCreatorV2/components/Treeselect/TreeselectProfileOption.ts.vue';
import useAdAccountStore from '@/views/Automation/CampaignCreatorV2/store/AdAccount';
import useCreativeStore from '@/views/Automation/CampaignCreatorV2/store/Creative';
import { SupportedEntities } from '@/views/Automation/CampaignCreatorV2/store/Types';
import { CardLayer, TreeselectOptionProfile } from '@/views/Automation/CampaignCreatorV2/types';
import { AdABGroups } from '@/views/Automation/CampaignCreatorV2/validation/Ad';
import Treeselect from '@riophae/vue-treeselect';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Identity.ts',
  setup(__props) {

const adAccountStore = useAdAccountStore();
const creativeStore = useCreativeStore();
const adAccountGetters = storeToRefs(adAccountStore);
const creativeGetters = storeToRefs(creativeStore);

const loadingMessageForPages = computed(() => {
  const account = adAccountGetters.currentAdAccount.value;
  if (account?.isDisabled) {
    return `Your Ad Account has issues: ${account?.message}`;
  }
  return 'Please wait, currently loading your Facebook Pages';
});

function getImageSource(images: { width: number; source: string }[] | undefined, preferredWidth: number): string {
  if (!images || images.length === 0) return '';
  return images.find((img) => img.width === preferredWidth)?.source || images[0].source;
}

const facebookPageOptions = computed((): TreeselectOptionProfile[] => {
  const pages = adAccountGetters.getFacebookPages.value.map((page): TreeselectOptionProfile => {
    const pageImg = getImageSource(page?.photos?.data[0].webp_images, 130);

    return {
      id: page.id,
      label: page.name,
      info: page.id,
      img: pageImg,
      isDisabled: page.id === 'loading',
    };
  });

  return pages;
});

const facebookPage = computed(() => {
  const field = creativeGetters.getField.value('actor_id');
  const variable = field?.value?.[0];
  const errors = [...((field as any)?.errors || []), ...(variable?.errors || [])];
  return {
    ...(variable || {}),
    errors,
  };
});
const instagramAccount = computed(() => creativeGetters.getField.value('instagram_actor_id')?.value?.[0]);

const instagramAccountOptions = computed((): TreeselectOptionProfile[] => {
  const currentFbPage = adAccountGetters.getFacebookPages.value?.find((page) => page.id === facebookPage.value?.value);
  const instagramOptions = [...(currentFbPage?.instagramOptions || [])].filter(Boolean);

  return instagramOptions.map(
    (account): TreeselectOptionProfile => ({
      id: account.id,
      label: account.username,
      info: account.username,
      img: account.profile_pic || '',
    })
  );
});

const onSelectFacebookPage = (value: { id: string }) => {
  creativeStore.removeVariable('instagram_actor_id', 'instagram_actor_id');
  creativeStore.addOrEditVariable('actor_id', {
    value: value.id,
    field: 'actor_id',
    variableId: 'actor_id',
  });
};

const onSelectInstagramAccount = (value: { id: string }) => {
  creativeStore.addOrEditVariable('instagram_actor_id', {
    value: value.id,
    field: 'instagram_actor_id',
    variableId: 'instagram_actor_id',
  });
};

return { __sfc: true,adAccountStore, creativeStore, adAccountGetters, creativeGetters, loadingMessageForPages, getImageSource, facebookPageOptions, facebookPage, instagramAccount, instagramAccountOptions, onSelectFacebookPage, onSelectInstagramAccount, CcCard, CcCardItem, CcError, CcVariableTags, TreeselectProfileOption, SupportedEntities, CardLayer, AdABGroups, Treeselect }
}

})